
import React, { useEffect, useState, useRef } from 'react'
import { InputBox, SelectInputBox, FormButton, Switch, AutoCompleteBox, AutoCompleteBoxWithLabel, DateBox } from "../commoncomponents/InputBox";
import { useAuth } from '../../context/auth';
import { Table } from '../commoncomponents/Table';
//loder
import BlurLoader from "../Loder/BlurLoader";
//react toast 
import { toast } from 'react-toastify';
//common Data
import { API_SERVER, handleDownloadExcel, initializeFilterData } from '../../Utils';
//services
import { post } from '../../apiservices/service';
import { getCommonData, getMasterData } from '../../apiservices/CommonServices';
import { Token, dateFormate, number, numberwithDot } from '../Common/Common';

function LateReport() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();
    const TokenData = Token()
    //initial state
    const [recipe, setRecipe] = useState({
        FromDate: new Date(),
        ToDate: new Date(),
        Employee: '',
        Department: '',
        Detailed: false
    })

    const [result, setResult] = useState({});
    const [loading, setLoading] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData);
    const [isUpdate, setIsUpdate] = useState(false);
    const [companyAllData, setCompanyAllData] = useState([])
    const [errors, setErrors] = useState({});
    const [showTable, setShowTable] = useState(false)
    const [employeeAllData, setEmployeeAllData] = useState([])
    const [shiftData, setShiftData] = useState([])
    const [departmentAllData, setDepartmentAllData] = useState([])

    //Get Employee Data for AutoComplete
    const GetEmployeeData = (value) => {
        setEmployeeAllData([])
        let temp = {
            Type: "GetEmployee",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setEmployeeAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setEmployeeAllData(data)
                }
            }
        });
    }

    const getDepartmentData = (value) => {
        let temp = {
            Type: "GetCompanyWiseDepartment",
            Prefix: value ? value : '',
            ContextKey: recipe.Company ? recipe.Company : '',
            ContextKey2: ""
        }
        //     setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setDepartmentAllData([])
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setDepartmentAllData(data)
                }
            }
        });
    }

    //Submit Handler
    const handleSubmit = (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let temp = {
            PageIndex: PageIndex.toString(),
            SearchText: "",
            StartValue: "1",
            SearchFieldValue: "",
            Type: "s"
        }
        setLoading(true)
        post(`${API_SERVER}api/Report/ShowBreakReportBiometric`, { ...TokenData, ...temp, ...sortConfig, ...filterData, ...recipe }, (res) => {
            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    toast.error(res.Message)
                    setLoading(false)
                    setResult({ ...res })
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    toast.success(res.message)
                    setResult({ ...res })
                    setShowTable(true)
                }
            }
        });

    }

    const handleChange1 = (event, value) => {
        handleSubmit(value);
    };

    useEffect(() => {
        inputrefs.current['txtEmployee'].focus();
        document.title = 'Viva HRMS : Break Report Biometric';
        getDepartmentData()
        GetEmployeeData();
        if (sortConfig.SortOrder !== null) handleSubmit();
    }, [sortConfig, isUpdate])

    //Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({
            ...recipe,
            FromDate: new Date(),
            ToDate: new Date(),
            Employee: '',
            Department: '',
            Detailed: false
        }))
        setErrors({})
        setFilterData(filterData => ({ ...filterData, SearchText: '' }))
        setIsUpdate(!isUpdate)
        setShowTable(false)
        inputrefs.current['txtCompany'].focus();
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    let DepartmentData = []
    for (let i = 0; i < departmentAllData.length; i++) {
        let mydata = departmentAllData[i]?.values
        DepartmentData.push(mydata)
    };

    let EmployeeData = []
    for (let i = 0; i < employeeAllData.length; i++) {
        let mydata = employeeAllData[i]?.values
        EmployeeData.push(mydata)
    };
    //Start Export functionality
    let ExportRequest = {
        ...filterData,
        ...TokenData,
        ...sortConfig,
        ...recipe,
        Type: 'E',
        PageIndex: '1'
    }
    //End Export functionality

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">Break Report Biometric</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>

                        <DateBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtToDate'].focus() };
                            }}
                            id='txtFromDate'
                            label='From Date'
                            placeholder="From Date"
                            selected={recipe.FromDate === '' ? '' : new Date(recipe.FromDate)}
                            onChange={(e) => HandleChange('FromDate', dateFormate(e))}
                        />

                        <DateBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtEmployee'].focus() };
                            }}
                            id='txtToDate'
                            label='To Date'
                            placeholder="To Date"
                            selected={recipe.ToDate === '' ? '' : new Date(recipe.ToDate)}
                            onChange={(e) => HandleChange('ToDate', dateFormate(e))}
                        />

                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDepartment'].focus() };
                            }}
                            label='Employee'
                            placeholder="Employee"
                            maxLength='50'
                            options={EmployeeData}
                            id='txtEmployee'
                            key='txtEmployee'
                            inputValue={recipe.employee ? recipe.employee : ''}
                            onInputChange={(event, newInputValue) => {
                                GetEmployeeData(newInputValue)
                                HandleChange('employee', newInputValue)

                            }}
                        />

                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDetailed'].focus() };
                            }}
                            label='Department'
                            placeholder="Department"
                            maxLength='50'
                            options={DepartmentData}
                            id='txtDepartment'
                            key='txtDepartment'
                            inputValue={recipe.Department ? recipe.Department : ''}
                            onInputChange={(event, newInputValue) => {
                                HandleChange('Department', newInputValue)
                                getDepartmentData(newInputValue)
                            }}
                        />
                        <Switch
                            inputrefs={inputrefs}
                            label='Detailed'
                            checked={recipe.Detailed}
                            id='txtDetailed'
                            nextinputid='txtFranchiseGroup'
                            onChange={(e) => HandleChange('Detailed', e.target.checked)}
                        />
                        <FormButton
                            saveButtonIcon='fa-search'
                            SaveText='Search'
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(API_SERVER + 'api/Report/ShowBreakReportBiometric', ExportRequest, 'Break Report Biometric')}
                            handleClear={handleClear}
                        />

                    </div>
                </div>
            </div>
            {showTable &&
                <Table
                    Filter={false}
                    Action={false}
                    Token={TokenData}
                    PageName='BreakReportBiometric'
                    handleFilter={() => {
                        handleSubmit();
                        setFilterData({
                            ...filterData,
                        });
                    }}
                    tableData={result}
                    loading={loading}
                    filterData={filterData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    handleSorting={handleSorting}
                    sortConfig={sortConfig}
                />
            }
            {loading && < BlurLoader />}
        </>
    )
}

export default LateReport
